<style scoped>
table tr td {
  text-align: left !important;
}
table {
  text-align: left !important;
}
</style>
<template>
  <CCard> 
    <div
      class="card-header bg-primary font-weight-bold text-white d-flex align-items-center"
    > Penerima Waiver
      <Button
        class="btn btn-md btn-success px-4 py-2 ml-auto mr-2"
        @click="tambahPenerima"
      >Tambah</Button>
      <Button
        class="btn btn-md btn-dark px-4 py-2 text-white"
        @click="$router.go(-1)"
      >
        Kembali
      </Button>
    </div>   
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <h6 class="my-3"> File Download : <a :href="formatFileUrl"> Download Format Upload Waiver</a></h6>
          </div>
        </div>
        <div class="col-sm-12 col-xl-12">
          <div class="form-group">
            <label for>Upload Data Penerima Waiver</label>
            <div class="custom-file text-truncate">
                <input 
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"                  
                  @change="uploadFile"
                />
                <label
                  class="custom-file-label"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                >
                  {{ filename }}
                </label>
              </div>
          </div>
        </div>
        <div class="col-sm-12 col-xl-12 text-right">
          <button class="btn btn-md btn-success px-3" @click="importFile">Submit</button>
        </div>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name="pageSize" id="pageSize" @change="changePageSize" v-model.number="pageSize">
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option value="Semua Data">Semua Data</option>
            </select>
          </div>
        </div>  
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name="search"
              id="search"
              class="form-control"
              placeholder="Cari Data ..."
              @keyup="cariData"
              v-model="search"
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht:100% !important" 
            :items="items" 
            :fields="fields" 
            hover 
            sorter
          >
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>                   
            <template #nama_lengkap="{item}">
              <td class="py-2">{{item.nama_lengkap ? item.nama_lengkap : item.nama_anggota}}</td>
            </template>           
            <template #email="{item}">
              <td class="py-2">{{item.email ? item.email : item.email_sementara}}</td>
            </template>            
            <template #nama_waiver="{item}">
              <td class="py-2">{{item.nama_waiver ? item.nama_waiver : "-"}}</td>
            </template>
            <template #nama_instansi="{item}">
              <td class="py-2">{{item.nama_instansi ? item.nama_instansi : "-"}}</td>
            </template>
            <template #status_pengajuan="{item}">
              <td class="py-2 font-weight-bold text-success" v-if="item.status_pengajuan == 1">Terdaftar</td>
              <td class="py-2 font-weight-bold text-danger"  v-else>Belum Terdaftar</td>
            </template>
            <template #file="{item}">
              <td class="py-2 font-weight-bold">
                <button  
                  :disabled="!item.file" 
                  @click="lihatFile(item.file)"
                  :class="!item.file ? 'btn btn-secondary text-white' : 'btn btn-warning text-white'"
                >
                  <small>Lihat File</small>
                </button>                
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <CButton 
                  :disabled="item.id_user === null || item.id_user === '' || item.id_user === '-'"
                  v-c-tooltip="'Upload Waiver'" 
                  class="mr-2" 
                  color="info" 
                  square 
                  size="sm" 
                  @click="uploadData(item, index)"
                >
                  <font-awesome-icon icon="upload" />
                </CButton>
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />&nbsp;&nbsp;
                </CButton>
              </td>
            </template>
          </CDataTable>    
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />    
        </CCol>
      </CRow>      

      <CModal
        title="Modal title"
        :show.sync="modalUpload"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Upload Waiver</h6>
        </template>
        <CForm>
          <CRow>
            <CCol sm="12 mb-3">              
              <div class="custom-file text-truncate">
                <input 
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"    
                  @change="uploadFileWaiver"              
                />
                <label
                  class="custom-file-label"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                >
                  {{ filenameWaiver }}
                </label>
              </div>
              <small class="text-danger">(*File harus bertipe PDF max. 10MB)</small>
            </CCol>
          </CRow>
        </CForm>        
        <template #footer class="mt-2">
          <CButton @click="modalUpload = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>

    </CCardBody>
    <ModalTambahPenerima
      :modalTambah="modalTambah"
      :title="'Tambah Penerima'"
      :formData="formDataPenerima"       
      :optionDataAnggota="optionDataAnggota"
      :dataAnggotaModel="dataAnggotaModel"
      @closeModalTambah="closeModalTambah($event)"   
    />
  </CCard>
</template>
<script>
import PenerimaWaiverService from "@/services/rpl/penerima-weiver.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import BaseUrl from "@/services/base-url";

import ModalTambahPenerima from "../../../components/rpl/datapeserta/waiver/ModalTambahPenerima"
import { DataKeanggotaan } from "../../../mixins/DataKeanggotaan"
const fields = [
  {
    key: "no",
    sorter: true,
    filter: true
  },    
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: true
  },    
  {
    key: "email",
    label: "Email",
    sorter: true,
    filter: true
  },
  {
    key: "nama_waiver",
    label: "Waiver",
    sorter: true,
    filter: true
  },
  
  {
    key: "nama_instansi",
    label : "Instansi",    
    sorter: true,
    filter: true
  },  
  {
    key: "status_pengajuan",
    label : "Status",    
    sorter: true,
    filter: true
  },  
  {
    key: "file",
    label : "Lihat File",    
    sorter: true,
    filter: true
  },  
  {
    key: "aksi",
    label : "Aksi",    
    sorter: true,
    filter: true
  },
];

export default {
  name: 'penerima-waiver',
  mixins: [
    AlertUtils,
    DataKeanggotaan
  ],
  components : {
    ModalTambahPenerima
  },
  data() {
    return {
      items:[],      
      actionPost: "",      
      search: "",
      pageSize: 10,      
      dataAnggotaModel : [],      
      formData: {        
        id_dat_waiver: "",        
        file: "",
        tipePenerima: 'iapi'
      },
      formDataPenerima : {
        idWaiver : '',
        idUser : '',
        alasan : '',
        namaLengkap : '',
        noTelepon : '',
        email : '',
        tipePenerima: 'iapi'
      },
      filename: 'Pilih File',
      filenameWaiver: "Pilih File",
      fileToImport: '',
      pagination: {
        totalPages: 0
      },
      fields,      
      modalTambah : false,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      modalUpload: false,
      myModalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      indexed: 0,
      title: "",
      baseUrl: BaseUrl(),
      formatFileUrl: BaseUrl()+'/files?filename=FORMAT_IMPORT_WAIVER.xlsx&path=dataweiver@pengajuanweiver'
    }
  },

  mounted() {
    this.getAllDataAnggota();
    this.getData("0", this.pageSize, "default");   
  },

  watch: {
    multi_user: function(val) {
      this.formData.idUser = val.id_user;
    },
    currentPage: function(val) {      
      var page = val - 1;
      this.indexed = page * this.pageSize;
      this.getData(val - 1, this.pageSize, this.search);
    }
  },

  methods: { 
    closeModalTambah(val) {      
      if(val === false) {
        this.modalTambah = false
      }      
    },   
    tambahPenerima(){
      this.modalTambah = true;
      this.formDataPenerima.idWaiver = this.$route.params.idWaiver;
    }, 
    changePageSize(e) {      
      var pageSize = "";
      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },    

    cariData() {
      setTimeout(() => {
        this.getData("0", this.pageSize, this.search);
      }, 1000)
    },    

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      const idWaiver = this.$route.params.idWaiver
      PenerimaWaiverService.getDataWaiver(currentPage, pageSize, filter, idWaiver)
        .then(response => {
          loader.hide();          
          this.items = response.data.data.content;        
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },    

    uploadData(item, index) {
      this.formData.id_dat_waiver = item.id_dat_waiver;
      this.modalUpload = true;      
    },

    uploadFileWaiver(e) {
      this.filenameWaiver = e.target.files[0].name;      
      this.formData.file = e.target.files[0]
    },

    uploadFile(e) {      
      this.filename = e.target.files[0].name;
      this.fileToImport = e.target.files[0]
    },

    importFile() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });

      PenerimaWaiverService.importDataWeiver(this.$route.params.idWaiver, this.fileToImport)
        .then((response) => {
          this.filename = 'Pilih File';
          this.fileToImport = '';
          this.getData(this.currentPage - 1, this.pageSize, this.search);
          this.alertSuccess(response.data.message)     
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.error(error)
        })
    },    

    deleteData(item, index) {
      // comment console console.log(index)
      // comment console console.log(item)
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            PenerimaWaiverService.deleteDataPenerimaWeiver(item.id_dat_waiver)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();            
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError(error.response.data.message);
                // comment console console.log(error.response.data.message);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    lihatFile(file) {
      if (file != "" && file != null) {       
        let routeData =
          this.baseUrl +
          "/files?filename=" +
          file +
          "&path=dataweiver@pengajuanweiver";
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000`;
        window.open(
         routeData,
          file,
          params
        );
        return false;
      } else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true
        });
      }
    },

    postData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });

      PenerimaWaiverService.putStatusPengajuanWaiver(this.formData)
      .then((response) => {
        this.formData = {};
        this.modalUpload = false;
        loader.hide();
        this.alertSuccess(response.data.message)
        this.getData(this.currentPage - 1, this.pageSize, this.search);
      })
      .catch((error) => {
        this.formData = {};
        this.modalUpload = false;
        loader.hide();
        this.alertError(error)
        this.getData(this.currentPage - 1, this.pageSize, this.search);
      })
    },

    postDataPenerima(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });

      PenerimaWaiverService.postDataPenerimaWaiver(formData)
      .then((response) => {
        this.dataAnggotaModel = []
        this.formDataPenerima.alasan = '';
        this.formDataPenerima.idUser = '';
        this.modalTambah = false
        loader.hide();
        this.alertSuccess(response.data.message)
        this.getData(this.currentPage - 1, this.pageSize, this.search);
      })
      .catch((error) => {
        this.dataAnggotaModel = []
        this.formDataPenerima.alasan = '';
        this.formDataPenerima.idUser = '';
        this.modalTambah = false
        
        loader.hide();
        this.alertError(error.response.data.message)
        this.getData(this.currentPage - 1, this.pageSize, this.search);
      })
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
  button:disabled {
    cursor: no-drop;
  }
</style>